var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / rocket"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77998 6.43C9.48998 6.77 9.22998 7.14 8.97998 7.52C8.27998 8.6 6.49998 11.69 6.13998 12.31H6.12998C5.15998 12.68 4.06998 13.06 3.35998 13.32C3.06998 13.42 2.80998 13.13 2.95998 12.86C3.64998 11.49 4.86998 9.26 5.42998 8.26C5.62998 7.89 6.06998 7.39 6.41998 7.17C7.40998 6.5 8.54998 6.31 9.77998 6.43Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.66 18.41C17.43 18.75 16.94 19.19 16.57 19.4C15.57 19.96 13.34 21.18 11.97 21.87C11.7 22.01 11.41 21.75 11.51 21.47C11.76 20.75 12.16 19.68 12.52 18.69C13.15 18.32 16.23 16.55 17.32 15.85C17.7 15.6 18.07 15.34 18.41 15.07C18.52 16.31 18.33 17.44 17.66 18.42V18.41Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66998 18.35C7.59998 19.42 5.64998 20.13 5.16998 19.65C4.66998 19.15 5.50998 17.12 6.46998 16.15C7.07998 15.54 8.05998 15.54 8.66998 16.15C9.27998 16.76 9.27998 17.74 8.66998 18.35Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.83 3.99C19.95 3.56 18.85 3.41 17.54 3.53C16.32 3.64 15.1 3.98 13.95 4.54C12.37 5.32 11 6.57 9.97998 8.16C9.83998 8.39 9.61998 8.72 9.39998 9.11C8.91998 9.89 8.34998 10.87 7.89998 11.65C7.66998 12.03 7.47998 12.36 7.33998 12.61L12.2 17.48C12.44 17.34 12.78 17.14 13.17 16.92C13.95 16.46 14.93 15.89 15.7 15.42C15.7 15.42 15.7 15.41 15.71 15.41C16.09 15.18 16.43 14.98 16.66 14.83C18.25 13.81 19.5 12.44 20.27 10.86C20.83 9.71 21.17 8.51 21.29 7.27C21.4 5.97 21.24 4.87 20.81 3.98L20.83 3.99ZM16.74 10.24C15.55 10.24 14.58 9.28 14.58 8.08C14.58 6.88 15.55 5.92 16.74 5.92C17.93 5.92 18.9 6.88 18.9 8.08C18.9 9.28 17.94 10.24 16.74 10.24Z",
    fill: "#0C0C0C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.c7134d82356d0b37dfadd012294fd270.svg";
export { ForwardRef as ReactComponent };